import { IComponentOptions, IScope } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { OKR_VIEWS_LIST_SCREEN_PATH, OKR_VIEWS_LIST_SETTING_KEY } from "@gtmhub/okrs/okr-views/utils/okr-views-all-utils";
import { setPersistedScreenSettings } from "@gtmhub/shared/components/grid-filtering-bar";
import { IGHGridColumn } from "@gtmhub/shared/components/grid/grid.component";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { ShareableFilter } from "@webapp/shared/unified-filters/models/shareable-filters.models";

interface OkrViewsGridBindings {
  gridItems: ShareableFilter[];
  columns: IGHGridColumn[];
}

interface OkrsViewsGridScope extends IScope, IExtendedRootScopeService {
  changeColumnWidth(): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface OkrViewsGridCtrl extends OkrViewsGridBindings {}

class OkrViewsGridCtrl extends GtmhubController {
  public static $inject = ["$scope"];

  constructor(private $scope: OkrsViewsGridScope) {
    super();

    this.$scope.changeColumnWidth = this.changeColumnWidth;
  }

  private changeColumnWidth = (): void => {
    setPersistedScreenSettings(OKR_VIEWS_LIST_SCREEN_PATH, OKR_VIEWS_LIST_SETTING_KEY, this.columns);
  };
}

export const OkrViewsGridComponent: IComponentOptions = {
  bindings: {
    gridItems: "<",
    columns: "<",
  },
  controller: OkrViewsGridCtrl,
  template: require("./okr-views-grid.component.html"),
};
